import { render, staticRenderFns } from "./OrderFrom.vue?vue&type=template&id=137e2f6c&scoped=true"
import script from "./OrderFrom.vue?vue&type=script&lang=js"
export * from "./OrderFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e2f6c",
  null
  
)

export default component.exports